import { render, staticRenderFns } from "./OurPartnersSection.vue?vue&type=template&id=0e0fbc24&scoped=true&"
import script from "./OurPartnersSection.vue?vue&type=script&lang=ts&"
export * from "./OurPartnersSection.vue?vue&type=script&lang=ts&"
import style0 from "./OurPartnersSection.vue?vue&type=style&index=0&id=0e0fbc24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0fbc24",
  null
  
)

export default component.exports